import React, { Component } from "react";
import ApiRequest from "../../libs/request";
import Modal from "react-modal";
import Reviews from "./Reviews";
import { FaTimesCircle } from "react-icons/fa";
import FriendList from "./FriendList";
import ReportUser from "./ReportUser";

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "500px",
    padding: "0px",
    borderRadius: "10px",
  },
};

class ProfileStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      more: "none",
      requestSent: props.user?.request_sent, // initialize with prop value
    };

    this.handleReviews = this.handleReviews.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    // Check if request_sent prop has changed
    if (prevProps.user?.request_sent !== this.props.user?.request_sent) {
      this.setState({ requestSent: this.props.user?.request_sent });
    }
  }

  handleSendRequest(friend) {
    try {
      var api = new ApiRequest("post", "/user/send-friend-request");
      api.send({ friend_id: friend.id }, () => {
        // make request_sent true to hide the add friend button
          this.setState({ requestSent: true }); // Update the state here
      }, );
    }
    catch (e) {
      console.log("error: ", e);
    }
}

  render() {
    var rating = this.props.user?.rating ? this.props.user?.rating : "0.0";
    const { requestSent } = this.state;
    var review_request_btn = (
      <React.Fragment>
        <div className="ctrls" style={{ display: this.state.more }}>
          <button
            type="button"
            id="review-btn"
            onClick={this.handleReviewRequest.bind(this)}
          >
            Review Request
          </button>
          <button
            type="button"
            id="review-btn"
            onClick={this.handleReportUser.bind(this)}
          >
            Report User
          </button>
          <button
            type="button"
            id="review-btn"
            onClick={() =>
              (location.href = "/messages?user_id=" + this.props.user?.id)
            }
          >
            Send Message
          </button>
        </div>
      </React.Fragment>
    );

    if (!this.props.showRequestButton) {
      review_request_btn = "";
    }
    var _comp = <Reviews user={this.props.user} />;
    if (this.state.modalComponent == "Friends") {
      _comp = (
        <FriendList
          showRequestButton={this.props.showRequestButton}
          user={this.props.user}
        />
      );
    }
    if (this.state.modalComponent == "Report User") {
      _comp = (
        <ReportUser
          onReportComplete={() => this.setState({ showModal: false })}
          user={this.props.user}
        />
      );
    }
    var _dots = (
      <span
        className="more-dots"
        onClick={() =>
          this.setState({
            more: this.state.more == "block" ? "none" : "block",
          })
        }
      >
        ...
      </span>
    );
    if (!this.props.showRequestButton) {
      _dots = "";
    }
    var stats = (
      <React.Fragment>

        <a
          href={"/?user_id=" + this.props.user?.id}
          style={{ color: "#FF9500" }}
        >
          <span style={{ color: "#FF9500", fontWeight: "bold" }}>
            {this.props.user?.post_count}
          </span>{" "}
          Posts
        </a>{" "}
        &nbsp;&nbsp;&nbsp;
        <a
          href="javascript:void(0)"
          style={{ color: "#FF9500" }}
          onClick={this.handleFriends.bind(this)}
        >
          <span style={{ color: "#FF9500", fontWeight: "bold" }}>
            {this.props.user?.friend_count}
          </span>{" "}
          Friends
        </a>{" "}

        {!requestSent && (
          <button
            style={{
              marginLeft: "10px",
            }}
            id={this.props.user?.id}
            className={"actionbtn suggested-frnd-btn"}
            type="button"
            onClick={() => {
              this.handleSendRequest(this.props.user);

            }}
          >
            Add Friend
          </button>
        )}

        {/* {_dots} */}
        <div className="profile-modals">
          <Modal
            isOpen={this.state.showModal}
            style={customModalStyles}
            contentLabel="Reviews"
            shouldCloseOnOverlayClick={true}
            overlayClassName="overlay"
          >
            <div className="modalHeader">
              {this.state.modalComponent}
              <div className="modalClose">
                <FaTimesCircle onClick={this.handleCloseModal.bind(this)} />
              </div>
            </div>
            <div className="modalContent">{_comp}</div>
          </Modal>
        </div>
      </React.Fragment>
    );

    return stats;
  }

  handleReviewRequest() {
    document.getElementById("review-btn").innerHTML = "Request Sent";
    let api = new ApiRequest("post", "/friends/request_review");
    api.send({ follower_id: this.props.user?.id }, (result) => { });
  }

  handleReportUser() {
    this.setState({ modalComponent: "Report User", showModal: true });
  }

  handleReviews() {
    this.setState({ modalComponent: "Reviews", showModal: true });
  }
  handleFriends() {
    this.setState({ modalComponent: "Friends", showModal: true });
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }
}
export default ProfileStats;
